import { MUTED } from './muted';

export const LINK = {
  linkText: MUTED.muted50,
  linkVisited: MUTED.muted100,
  linkHover: MUTED.muted200,
  linkActive: MUTED.muted300,
};
